"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient["default"];
  }
});
Object.defineProperty(exports, "BranchApi", {
  enumerable: true,
  get: function get() {
    return _BranchApi["default"];
  }
});
Object.defineProperty(exports, "BranchDto", {
  enumerable: true,
  get: function get() {
    return _BranchDto["default"];
  }
});
Object.defineProperty(exports, "BranchEntityDto", {
  enumerable: true,
  get: function get() {
    return _BranchEntityDto["default"];
  }
});
Object.defineProperty(exports, "BranchGetResponseEntity", {
  enumerable: true,
  get: function get() {
    return _BranchGetResponseEntity["default"];
  }
});
Object.defineProperty(exports, "BranchGetResponseMetadata", {
  enumerable: true,
  get: function get() {
    return _BranchGetResponseMetadata["default"];
  }
});
Object.defineProperty(exports, "BulkImportApi", {
  enumerable: true,
  get: function get() {
    return _BulkImportApi["default"];
  }
});
Object.defineProperty(exports, "HospitalDto", {
  enumerable: true,
  get: function get() {
    return _HospitalDto["default"];
  }
});
Object.defineProperty(exports, "HospitalEntityDto", {
  enumerable: true,
  get: function get() {
    return _HospitalEntityDto["default"];
  }
});
Object.defineProperty(exports, "HospitalLocation", {
  enumerable: true,
  get: function get() {
    return _HospitalLocation["default"];
  }
});
Object.defineProperty(exports, "HospitalLocationDto", {
  enumerable: true,
  get: function get() {
    return _HospitalLocationDto["default"];
  }
});
Object.defineProperty(exports, "HospitalLocationEntityDto", {
  enumerable: true,
  get: function get() {
    return _HospitalLocationEntityDto["default"];
  }
});
Object.defineProperty(exports, "HospitalUpdateDto", {
  enumerable: true,
  get: function get() {
    return _HospitalUpdateDto["default"];
  }
});
Object.defineProperty(exports, "ImportResultDto", {
  enumerable: true,
  get: function get() {
    return _ImportResultDto["default"];
  }
});
Object.defineProperty(exports, "ImportType", {
  enumerable: true,
  get: function get() {
    return _ImportType["default"];
  }
});
Object.defineProperty(exports, "ScanFacilityApi", {
  enumerable: true,
  get: function get() {
    return _ScanFacilityApi["default"];
  }
});
Object.defineProperty(exports, "ScanFacilityDto", {
  enumerable: true,
  get: function get() {
    return _ScanFacilityDto["default"];
  }
});
Object.defineProperty(exports, "ScanFacilityEntityDto", {
  enumerable: true,
  get: function get() {
    return _ScanFacilityEntityDto["default"];
  }
});
Object.defineProperty(exports, "StatusMessageDto", {
  enumerable: true,
  get: function get() {
    return _StatusMessageDto["default"];
  }
});
Object.defineProperty(exports, "UserApi", {
  enumerable: true,
  get: function get() {
    return _UserApi["default"];
  }
});
Object.defineProperty(exports, "UserDto", {
  enumerable: true,
  get: function get() {
    return _UserDto["default"];
  }
});
Object.defineProperty(exports, "UserEntityDto", {
  enumerable: true,
  get: function get() {
    return _UserEntityDto["default"];
  }
});
var _ApiClient = _interopRequireDefault(require("./ApiClient"));
var _BranchDto = _interopRequireDefault(require("./model/BranchDto"));
var _BranchEntityDto = _interopRequireDefault(require("./model/BranchEntityDto"));
var _BranchGetResponseEntity = _interopRequireDefault(require("./model/BranchGetResponseEntity"));
var _BranchGetResponseMetadata = _interopRequireDefault(require("./model/BranchGetResponseMetadata"));
var _HospitalDto = _interopRequireDefault(require("./model/HospitalDto"));
var _HospitalEntityDto = _interopRequireDefault(require("./model/HospitalEntityDto"));
var _HospitalLocation = _interopRequireDefault(require("./model/HospitalLocation"));
var _HospitalLocationDto = _interopRequireDefault(require("./model/HospitalLocationDto"));
var _HospitalLocationEntityDto = _interopRequireDefault(require("./model/HospitalLocationEntityDto"));
var _HospitalUpdateDto = _interopRequireDefault(require("./model/HospitalUpdateDto"));
var _ImportResultDto = _interopRequireDefault(require("./model/ImportResultDto"));
var _ImportType = _interopRequireDefault(require("./model/ImportType"));
var _ScanFacilityDto = _interopRequireDefault(require("./model/ScanFacilityDto"));
var _ScanFacilityEntityDto = _interopRequireDefault(require("./model/ScanFacilityEntityDto"));
var _StatusMessageDto = _interopRequireDefault(require("./model/StatusMessageDto"));
var _UserDto = _interopRequireDefault(require("./model/UserDto"));
var _UserEntityDto = _interopRequireDefault(require("./model/UserEntityDto"));
var _BranchApi = _interopRequireDefault(require("./2/BranchApi"));
var _BulkImportApi = _interopRequireDefault(require("./2/BulkImportApi"));
var _ScanFacilityApi = _interopRequireDefault(require("./2/ScanFacilityApi"));
var _UserApi = _interopRequireDefault(require("./2/UserApi"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }